import React from 'react';
interface ScrollHintTableProps {
  children: React.ReactNode;
  minWidth?: string;
}
export function ScrollHintTable({
  children,
  minWidth = '560px'
}: ScrollHintTableProps) {
  return <div data-id="element-292" data-mp="1i7ek6dxl99e0">
      <p className="mb-2 text-center text-xs font-medium text-muted sm:hidden" data-id="element-293" data-mp="1i6moz47wldo9">
        ← Desliza para ver la tabla completa →
      </p>
      <div className="scrollbar-hide overflow-x-auto rounded-2xl border border-brown/20 bg-white" data-id="element-294" data-mp="1mzfs5nnq4dy8">
        <div style={{
        minWidth
      }} data-id="element-295" data-mp="1rwfy7ykkpgpc">{children}</div>
      </div>
    </div>;
}